export default __webpack_public_path__ + "static/media/a014-longer.02d604f6.svg";